import { getStore } from '@/store'

import { isValidationErrorDialogOpenAtom } from '../generatorState'

export type TSaveQrResponse = {
	status: number
	data: {
		message: string
		validation: {
			invalidUrls: string[]
		}
	}
}

export const checkValidationErrors = (res: TSaveQrResponse) => {
	const dialogOpen = getStore().get(isValidationErrorDialogOpenAtom)
	if (
		res.status === 200 &&
		res.data?.validation?.invalidUrls?.length > 0 &&
		!dialogOpen
	) {
		getStore().set(isValidationErrorDialogOpenAtom, true)
		throw new Error('Validation error')
	}
}
